var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass: "cuori",
      class: { small: _vm.small },
      on: {
        click: function ($event) {
          $event.stopPropagation()
        },
      },
    },
    _vm._l(_vm.maxCuori, function (cuore) {
      return _c(
        "button",
        {
          key: cuore,
          staticClass: "cuori-btn",
          class: { "cuori-btn--active": cuore <= _vm.value },
          attrs: { type: "button" },
          on: {
            click: function ($event) {
              $event.stopPropagation()
              return _vm.selectCuori(cuore)
            },
          },
        },
        [_c("v-icon", [_vm._v("favorite")])],
        1
      )
    }),
    0
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }